import { useEffect } from "react";

export const PORTAL_CONTENT_ACTIVITY_EVENT = "pleiades:portal-content-activity";

export function emitPortalContentActivity(detail) {
  if (!detail?.content_type || !detail?.content_id) return;
  globalThis.dispatchEvent?.(
    new CustomEvent(PORTAL_CONTENT_ACTIVITY_EVENT, { detail }),
  );
}

function visibleSeconds(state) {
  const activeMs = state.visibleSince ? Date.now() - state.visibleSince : 0;
  return Math.max(0, Math.round((state.visibleMs + activeMs) / 1000));
}

export function usePortalContentActivity(content) {
  useEffect(() => {
    if (!content?.content_type || !content?.content_id || content.active === false) return;
    const state = {
      visibleMs: 0,
      visibleSince: document.visibilityState === "visible" ? Date.now() : null,
    };
    const base = {
      content_type: content.content_type,
      content_id: String(content.content_id),
      content_title: String(content.content_title || "").slice(0, 240),
    };
    const emit = (event_type) => emitPortalContentActivity({
      ...base,
      event_type,
      duration_seconds: visibleSeconds(state),
    });
    const onVisibility = () => {
      if (document.visibilityState === "visible" && !state.visibleSince) {
        state.visibleSince = Date.now();
      } else if (document.visibilityState !== "visible" && state.visibleSince) {
        state.visibleMs += Date.now() - state.visibleSince;
        state.visibleSince = null;
      }
    };

    emit("content_open");
    document.addEventListener("visibilitychange", onVisibility);
    const progressTimer = globalThis.setInterval?.(() => emit("content_progress"), 30000);
    return () => {
      if (state.visibleSince) {
        state.visibleMs += Date.now() - state.visibleSince;
        state.visibleSince = null;
      }
      globalThis.clearInterval?.(progressTimer);
      document.removeEventListener("visibilitychange", onVisibility);
      emit("content_close");
    };
  }, [content?.active, content?.content_id, content?.content_title, content?.content_type]);
}
